import * as React from "react";
import {SetImageModel} from "../../../data/model/Producer";
import {ChangeEvent, useRef} from "react";
import {getFileMediaType} from "../../../utils/Utils";
import {Button, HStack, Image, Input, Stack, StackProps, Text, VStack} from "@chakra-ui/react";
import {ImageIcon} from "../../atoms/SvgImage";
import {CloseIcon} from "@chakra-ui/icons";

interface ImageSelectorComponentProps extends StackProps {
    setImageModel?: React.Dispatch<React.SetStateAction<SetImageModel | undefined>>,
    setImageModelFunction?: (model?: SetImageModel) => void;
    imageModel: SetImageModel | undefined,
    isMain: boolean,
    description?: string,
    handleButtonClick?: () => void,
    handleCloseButtonClick?: ((model: SetImageModel) => void) | undefined,
}

export const ImageSelectorComponent = ({
                                           setImageModel,
                                           imageModel,
                                           isMain,
                                           description,
                                           handleButtonClick,
                                           handleCloseButtonClick,
                                           setImageModelFunction,
                                           ...other
                                       }: ImageSelectorComponentProps
) => {
    const logoInputRef: React.RefObject<HTMLInputElement> = useRef(null);

    const handleLogoChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            const file = event.target.files[0];

            const mediaType = getFileMediaType(file);

            setImageModel && setImageModel({
                file,
                imageUrl: URL.createObjectURL(file),
                isMain: true,
                mediaType
            });

            setImageModelFunction && setImageModelFunction({
                file,
                imageUrl: URL.createObjectURL(file),
                isMain: true,
                mediaType
            });
        }
    };

    const handleButtonClickInner = () => {
        logoInputRef?.current?.click();
        handleButtonClick && handleButtonClick();
    }

    return <VStack w={"100%"} alignItems={"flex-start"} {...other}>
        <Input
            type="file"
            id="image"
            accept="image/*"
            ref={logoInputRef}
            onChange={handleLogoChange}
            style={{display: 'none'}}
        />

        {!imageModel?.imageUrl && <Button
            colorScheme="teal"
            mt={"8px"}
            w={"100%"}
            h={"64px"}
            leftIcon={<ImageIcon w={"32px"} h={"32px"}/>}
            onClick={handleButtonClickInner}>Scegli un'immagine</Button>}

        {!imageModel?.imageUrl && description && <Text fontSize={"14px"} color={"rgba(0,0,0,0.6)"}>{description}</Text>}

        {imageModel?.imageUrl && <HStack borderRadius={"16px"} gap={'16px'} overflow={"hidden"}
                                        position={"relative"}>
            <Image src={imageModel.imageUrl} alt="Uploaded Image" maxW={"300px"}/>
            <CloseIcon cursor={"pointer"} right={"8px"} top={"8px"} position={"relative"}
                       borderRadius={"50%"} color={"white"} p={"8px"}
                       w={"32px"}
                       h={"32px"}
                       alignSelf={'flex-start'}
                       backgroundColor={"error.700"}
                       onClick={() => {
                           setImageModel && setImageModel(undefined);
                           setImageModelFunction && setImageModelFunction(undefined);
                           handleCloseButtonClick && handleCloseButtonClick(imageModel);
                           if (logoInputRef.current) {
                               logoInputRef.current.value = '';
                           }
                       }}/>
        </HStack>}
    </VStack>;
}
